import React, { memo } from "react";
import { EDSBadge } from "../../eds/EDSBadge";
import { cn } from "../../../lib/utils";

type CustomPillType = {
  loading?: boolean;
  label: string;
  backgroundColour?: string;
  labelColour?: string;
  softenColour?: boolean;
  className?: string;
  style?: React.CSSProperties;
};

const normaliseColour = (colour?: string): string | undefined => {
  if (!colour) return undefined;
  if (colour.startsWith("#") || colour.startsWith("rgb")) return colour;
  return `#${colour}`;
};

const CustomPill = ({
  loading,
  label,
  backgroundColour,
  labelColour,
  softenColour,
  className: externalClassName,
  style: externalStyle
}: CustomPillType) => {
  const className = cn(
    "CustomPill",
    softenColour && "SoftenColour",
    loading && "Loading",
    "relative",
    "capitalize",
    "text-[10px]",
    "font-bold",
    "text-center",
    "leading-tight",
    "min-h-[19px]",
    "h-auto",
    "px-3",
    "py-0.5",
    "break-words",
    "rounded",
    externalClassName
  );

  const style: React.CSSProperties = {
    backgroundColor: normaliseColour(backgroundColour),
    color: normaliseColour(labelColour),
    ...(loading ? { minWidth: "70px" } : {}),
    ...externalStyle
  };

  return (
    <EDSBadge className={className} style={style}>
      <span className="Label">{label}</span>
    </EDSBadge>
  );
};

export default memo<CustomPillType>(CustomPill);
